import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/_staff/attendance-engine/_layout/attendance-structures/$structureId/_layout/')({
  beforeLoad: ({
    params
  }) => {
    throw redirect({
      to: '/attendance-engine/attendance-structures/$structureId/structure',
      params
    });
  }
});